import {
  LazyQueryHookOptions,
  QueryHookOptions,
  useLazyQuery,
  useQuery
} from '@apollo/react-hooks';
import { DocumentNode } from 'graphql';
import { merge } from 'lodash-es';

import useEffectOnUpdates from 'hooks/use-effect-on-updates';
import { useLocale } from 'state/intl';
import { useNetworkContext } from 'state/network';

const useSanityGqlEndpoint = () => useNetworkContext().sanityEndpoints.graphql;

export const useSanityQuery = <TData = any, TVariables = Record<string, any>>(
  query: DocumentNode,
  options: QueryHookOptions<TData, TVariables> = {}
) => {
  const uri = useSanityGqlEndpoint();
  const { language, region } = useLocale();

  const queryOptions = merge(options, { context: { uri } });

  const queryResult = useQuery<TData, TVariables>(query, queryOptions);

  const { refetch } = queryResult;

  useEffectOnUpdates(() => {
    refetch();
  }, [language, region]);

  return queryResult;
};

export const useLazySanityQuery = <TData = any, TVariables = Record<string, any>>(
  query: DocumentNode,
  options: LazyQueryHookOptions<TData, TVariables> = {}
) => {
  const uri = useSanityGqlEndpoint();

  const queryOptions = merge(options, { context: { uri } });

  return useLazyQuery<TData, TVariables>(query, queryOptions);
};

// for apollo codegen compatibility
export * from '@apollo/react-hooks';
export { useSanityQuery as useQuery, useLazySanityQuery as useLazyQuery };
